import React, { useState, forwardRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  changePdfViewerState,
  searchFinancialCustomer,
  sendFinancialPdf,
  changePdfInfo,
  planFinancialPDF,
  searchPlanComplete,
} from '@store/actions/pdfViewerAction';
import { isMobile } from '@common/utils/device';
import jumpToPagePlugin from '@container/pdfviewer/jumpToPagePlugin';

import { pageNavigationPlugin } from '@react-pdf-viewer/page-navigation';

import SatButton from '@components/common/satUI/SatButton';
import SatModal from '@components/common/satUI/SatModal';

import SharePdf from '@components/pdfViewer/SharePdf';
// import '@assets/scss/common.scss';
import '@react-pdf-viewer/core/lib/styles/index.css';
import EaIndex from '@container/ea/EaIndex';
import OmniIndex from '@container/omni/OmniIndex';

import DrawToolbar from '@components/pdfViewer/DrawToolbar';
import PdfViewer from '@container/pdfviewer/PdfViewer';
import useDrawablePdf from '@common/hooks/useDrawablePdf';
import ZoomPlugin from '@container/pdfviewer/ZoomPlugIn';
import { hideOmniPopup, showOmniPopup } from '@store/actions/omniAction';
import { hideEaPopup, showEaPopup } from '@store/actions/eaAction';

// import firebase from 'firebase/app';

const PDFViewer = props => {
  const {
    visible,
    url,
    fileType,
    setPdfVisible,
    planEstablishNo,
    applicationNo,
  } = props;

  const dispatch = useDispatch();
  const {
    eaReducer: { isShowEaPopup },
    omniReducer: { isShowOmniPopup },
    pdfViewerReducer: { financialPDFInfo, planShare, customer, bookmark },
  } = useSelector(state => state);

  // pdf 라이브러리 plugin
  const pageNavigationPluginInstance = pageNavigationPlugin();
  const { CurrentPageLabel } = pageNavigationPluginInstance;
  const jumpToPagePluginInstance = jumpToPagePlugin();
  const { jumpToPage } = jumpToPagePluginInstance;
  const zoomPluginInstance = ZoomPlugin();
  const { handleZoomInOut } = zoomPluginInstance;
  const { toggleCanvas } = useDrawablePdf();
  const [inDrawMode, setInDrawMode] = useState(false);

  const [isSharePopup, setIsSharePopup] = useState(false);
  const [shareType, setShareType] = useState('');
  const [infoPopup, setInfoPopup] = useState(false);
  const [infoMsg, setInfoMsg] = useState('');
  const [isSignPopup, setIsSignPopup] = useState(false);
  const [completePopup, setCompletePopup] = useState(false);

  const [progressPlan, setProgrssPlan] = useState({});

  const onClickBack = () => {
    //onClose();
    setPdfVisible(false);
  };

  // 청약 진행 버튼
  const handleClickSign = () => {
    dispatch(
      searchPlanComplete({
        planEstablishNo: financialPDFInfo.planEstablishNo,
        callback: callbackSucess,
      }),
    );
  };

  const callbackSucess = ({ type, data }) => {
    setProgrssPlan(data);
    if (type) {
      if (data.progressStep === 'R') {
        setCompletePopup(true);
      } else {
        setIsSignPopup(true);
      }
    }
  };

  // 카카오, 이메일 공유
  const handleClickShare = value => {
    setShareType(value);
    setIsSharePopup(true);
  };

  // 나에게만 보내기 클릭
  const handleClickSendOnly = value => {
    if (financialPDFInfo.virtlPlanYn !== 'Y') {
      let planShareStr = '';
      if (value) {
        if (shareType === 'SMS') {
          planShareStr = 'SMS-ONLY-TO-ME';
        } else {
          planShareStr = 'EMAIL-ONLY-TO-ME';
        }
      } else {
        if (shareType === 'SMS') {
          planShareStr = 'SMS';
        } else {
          planShareStr = 'EMAIL';
        }
      }
      dispatch(
        changePdfViewerState({
          type: 'planShare',
          data: {
            planEstablishNo: financialPDFInfo.planEstablishNo,
            shareType: planShareStr,
          },
        }),
      );
    }
  };

  // pdf 공유
  const handleClickSendPdf = () => {
    const { name, mobilTelNo: mobileTelNo, email: emailAddr } = customer;
    const contactInfo = { name, mobileTelNo, emailAddr };
    dispatch(sendFinancialPdf({ contactInfo, callback: sendCallback }));
  };

  const sendCallback = (type, msg) => {
    if (type) {
      setIsSharePopup(false);
      setShareType('');
    }
    setInfoPopup(true);
    setInfoMsg(msg);
  };

  // 목차 숨김 상태
  const [indexListStatus, setIndexListStatus] = useState(true);

  // 전차청약 팝업 노출 여부
  const setEaMainPopup = isShow => {
    if (isShow) dispatch(showEaPopup());
    else dispatch(hideEaPopup());
  };

  // 옴니 팝업 노출 여부
  const setOmniMainPopup = isShow => {
    if (isShow) dispatch(showOmniPopup());
    else dispatch(hideOmniPopup());
  };

  // 전자청약 팝업 View
  const handlerClickEaMain = () => {
    dispatch(
      changePdfInfo({
        planEstablishNo: planEstablishNo,
        applicationNo: applicationNo,
        fileType: 'P',
        virtlPlanYn: 'N',
      }),
    );
    dispatch(
      planFinancialPDF({
        planEstablishNo: planEstablishNo,
        applicationNo: applicationNo,
        fileType: 'P',
        callback: pdfCallbackSuccess,
      }),
    );
  };

  const pdfCallbackSuccess = ({ type, data }) => {
    if (type) {
      if (data.status !== 'R') {
        // setPdfErrorPopup(true);
        setIsSignPopup(false);
        setEaMainPopup(true);
      }
    }
  };

  // 옴니청약 팝업 view
  const handlerClickOmniMain = () => {
    dispatch(
      changePdfInfo({
        planEstablishNo: planEstablishNo,
        applicationNo: applicationNo,
        fileType: 'P',
        virtlPlanYn: 'N',
      }),
    );
    dispatch(
      planFinancialPDF({
        planEstablishNo: planEstablishNo,
        applicationNo: applicationNo,
        fileType: 'P',
        callback: omniCallbackSuccess,
      }),
    );
  };

  const omniCallbackSuccess = ({ type, data }) => {
    if (type) {
      if (data.status !== 'R') {
        setIsSignPopup(false);
        setOmniMainPopup(true);
      }
    }
  };

  const [currentPage, setCurrentPage] = useState('1');
  // 가입제안서 북마크 클릭
  const handleClickBookmark = value => {
    const splitPage = value.split(',');
    setCurrentPage(splitPage[0]);
    jumpToPage(Number(splitPage[0]) - 1);
  };

  const handlePageChange = value => {
    setCurrentPage(String(value.currentPage + 1));
  };

  useEffect(() => {
    if (isSharePopup) {
      let shareTypeStr = '';
      if (shareType === 'SMS') {
        if (financialPDFInfo.virtlPlanYn === 'Y') {
          shareTypeStr = 'SMS-ONLY-TO-ME';
        } else {
          shareTypeStr = 'SMS';
        }
      }

      if (shareType === 'EMAIL') {
        if (financialPDFInfo.virtlPlanYn === 'Y') {
          shareTypeStr = 'EMAIL-ONLY-TO-ME';
        } else {
          shareTypeStr = 'EMAIL';
        }
      }
      dispatch(
        changePdfViewerState({
          type: 'planShare',
          data: {
            planEstablishNo: financialPDFInfo.planEstablishNo,
            shareType: shareTypeStr,
          },
        }),
      );
    }
  }, [isSharePopup]);

  useEffect(() => {
    dispatch(searchFinancialCustomer());
  }, []);

  return (
    <>
      {/* <div
        className={`modal popup ${visible && 'open'}`}
        style={{ display: 'block' }}
      > */}
      <div className={`container pdf-view ${!indexListStatus && 'no-nav'}`}>
        {/* <div
            className="dim"
            style={{
              display:
                isSharePopup || isSignPopup || infoPopup ? 'block' : 'none',
              zIndex: 210,
            }}
          /> */}

        <nav className="nav">
          <div className="page-navi">
            <a className="btn-back" onClick={() => setPdfVisible(false)}>
              이전
            </a>
          </div>
          <div className="compare-scroll">
            {fileType === 'F' && <h1 className="pdf-tit">가입제안서 목차</h1>}
            {fileType === 'P' && <h1 className="pdf-tit">전자청약서 목차</h1>}
            <ul className="pdf-list">
              {bookmark.map((data, index) => {
                return (
                  <li
                    key={index}
                    onClick={() => handleClickBookmark(data.pn)}
                    className={
                      data.pn.split(',').includes(currentPage)
                        ? 'bold blue'
                        : ''
                    }
                  >
                    {data.title}
                  </li>
                );
              })}
            </ul>
          </div>
        </nav>

        {/* content */}
        <div className="content">
          {/* con-info */}
          <div className="con-info" style={{ zIndex: 1 }}>
            <div className="page-navi">
              <a className="btn-back" onClick={onClickBack}>
                이전
              </a>
            </div>
            <SatButton
              styleClass={indexListStatus ? 'btn-zoom-in' : 'btn-zoom-out'}
              onClick={() =>
                indexListStatus
                  ? setIndexListStatus(false)
                  : setIndexListStatus(true)
              }
            />
            <div className="box">
              <CurrentPageLabel>
                {RenderCurrentPageLabelProps => (
                  <>
                    <strong className="cur-p">
                      {RenderCurrentPageLabelProps.currentPage + 1}
                    </strong>{' '}
                    /
                    <span className="tot-p">
                      {RenderCurrentPageLabelProps.numberOfPages}
                    </span>
                  </>
                )}
              </CurrentPageLabel>
            </div>

            <div className="btn-group-menu">
              {/* button class 변경 */}
              <SatButton
                styleClass="btn-m-zoom-p"
                label={'+'}
                onClick={() => handleZoomInOut('p')}
              />
              <SatButton
                styleClass="btn-m-zoom-m"
                label={'-'}
                onClick={() => handleZoomInOut('m')}
              />

              {(isMobile.any() || $utils.isDevLocal) && (
                <SatButton
                  styleClass={`btn-m-write ${inDrawMode ? 'on' : ''}`}
                  onClick={() => {
                    setInDrawMode(prev => !prev);
                    toggleCanvas(!inDrawMode);
                  }}
                />
              )}

              {fileType === 'F' && (
                <>
                  <SatButton
                    styleClass={`btn-m-sns ${shareType === 'sms' && 'on'}`}
                    onClick={() => handleClickShare('SMS')}
                    // disabled
                  />
                  <SatButton
                    styleClass={`btn-m-email ${shareType === 'EMAIL' && 'on'}`}
                    onClick={() => handleClickShare('EMAIL')}
                    // disabled
                  />
                  {/* {financialPDFInfo.virtlPlanYn === 'N' && (
                      <SatButton
                        styleClass="btn-s blue"
                        label="청약 진행"
                        onClick={() => handleClickSign()}
                      />
                    )} */}
                </>
              )}
            </div>
          </div>
          {/* con-info */}

          {/* con-wrap */}
          <div className="con-wrap no-bottom">
            <div className="fbox">
              <PdfViewer
                url={url}
                handlePdfPageChange={handlePageChange}
                pageNavigationPluginInstance={pageNavigationPluginInstance}
                jumpToPagePluginInstance={jumpToPagePluginInstance}
                zoomPluginInstance={zoomPluginInstance}
              />
            </div>
            <DrawToolbar brushRange={{ min: 1, max: 20 }} />
          </div>
          {/* con-wrap */}
        </div>
        {/* content */}
      </div>
      {/* </div> */}
      <SatModal
        visible={isSignPopup}
        setVisible={() => {
          setIsSignPopup(false);
        }}
        type="info"
        onCloseButton
        render={() => {
          return (
            <div className="cont">
              <p className="layer-text text-center">
                {`청약 진행 방법을 선택해주세요.`}
              </p>
              <div className="btn-select">
                <button
                  type="button"
                  className="btn-face"
                  onClick={() => {
                    setIsSignPopup(false);
                    handlerClickEaMain(true);
                  }}
                >
                  고객과 함께 작성<span>(대면 전자청약)</span>
                </button>
                {progressPlan.omniYn && (
                  <button
                    type="button"
                    className="btn-omni"
                    onClick={() => {
                      setIsSignPopup(false);
                      handlerClickOmniMain(true);
                    }}
                  >
                    고객에게 전송<span>(모바일 옴니청약)</span>
                  </button>
                )}
              </div>
            </div>
          );
        }}
      />
      {shareType === 'SMS' &&
      !customer.mobilTelNo &&
      financialPDFInfo.virtlPlanYn !== 'Y' ? (
        <SatModal
          visible={isSharePopup}
          type="info"
          msg={
            '핸드폰번호가 등록되어있지 않습니다. 등록후 발송해 주시기 바랍니다.'
          }
          onOk={{
            handle: () => {
              setIsSharePopup(false);
              setShareType('');
            },
          }}
        />
      ) : (
        <SatModal
          visible={isSharePopup}
          type="confirm"
          render={() => {
            return (
              <>
                <SharePdf
                  financialPDFInfo={financialPDFInfo}
                  shareType={shareType}
                  planShare={planShare}
                  onChangeSendOnly={handleClickSendOnly}
                  customer={customer}
                />

                <div className="btn-group">
                  <SatButton
                    styleClass="btn-half cancel"
                    label={'취소'}
                    onClick={() => {
                      setIsSharePopup(false);
                      setShareType('');
                    }}
                  />
                  <SatButton
                    styleClass="btn-half confirm"
                    label={'확인'}
                    onClick={() => {
                      // CHECK ME : firebase 미연결/미사용, 추후 확인 후 제거 또는 사용 처리 필요
                      // if (shareType === 'SMS') {
                      //   firebase.analytics().logEvent('select_content', {content_type : 'sendKakao'});
                      // } else {
                      //   firebase.analytics().logEvent('select_content', {content_type : 'sendEmail'});
                      // }

                      setIsSharePopup(false);
                      handleClickSendPdf();
                    }}
                  />
                </div>
              </>
            );
          }}
        />
      )}
      <SatModal
        visible={infoPopup}
        type="info"
        msg={infoMsg}
        onOk={{
          handle: () => {
            setInfoPopup(false);
          },
        }}
      />
      <SatModal
        type="fullPop"
        visible={isShowEaPopup}
        setVisible={() => {
          setEaMainPopup(false);
        }}
      >
        <EaIndex
          setEaMainPopup={setEaMainPopup}
          planEstablishNo={financialPDFInfo.planEstablishNo}
          applicationNo={financialPDFInfo.applicationNo}
        />
      </SatModal>
      <SatModal
        type="fullPop"
        visible={isShowOmniPopup}
        setVisible={() => {
          setOmniMainPopup(false);
        }}
      >
        <OmniIndex
          setOmniMainPopup={setOmniMainPopup}
          planEstablishNo={financialPDFInfo.planEstablishNo}
          applicationNo={financialPDFInfo.applicationNo}
        />
      </SatModal>
      <SatModal
        visible={completePopup}
        setVisible={() => {
          setCompletePopup(false);
        }}
        type="info"
        render={() => {
          return (
            <div className="cont">
              <p className="layer-text info text-left">
                {`이미 청약접수가 된 설계입니다.`}
              </p>
              <SatButton
                styleClass="btn-l blue"
                label={'확인'}
                onClick={() => {
                  setCompletePopup(false);
                }}
              />
            </div>
          );
        }}
      />
    </>
  );
};

export default PDFViewer;
